import React from 'react'
import { Button, ErrorForm, InputForm, PopUpGeneric } from '../../components'
import { useNavigate } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { useYupValidation } from '../../hooks'
import { IPasswordEdit } from '../../interfaces'
import { editPasswordSchema } from '../../yup'
import { confirmAlert } from 'react-confirm-alert'
import { errorHandler, ProfileService } from '../../services'
import { toast } from 'react-toastify'
import { SpinnerLoader } from '../../assets/icons'

export default function EditPassword(): React.ReactElement {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = React.useState(false)

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IPasswordEdit>({
        resolver: useYupValidation(editPasswordSchema),
    })

    async function submit(values: IPasswordEdit): Promise<void> {
        setIsLoading(true)
        try {
            const profileContext = await ProfileService.patchPasswordUser(values)
            toast(profileContext.message, { type: 'success' })
            navigate('/profile')
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    function popUpConfirm(values: IPasswordEdit): void {
        confirmAlert({
            customUI: ({ onClose }) => (
                <PopUpGeneric
                    onConfirm={() => {
                        submit(values)
                        onClose()
                    }}
                    onCancel={onClose}
                    title={'Deseja salvar as alterações?'}
                />
            ),
        })
    }

    return (
        <div className="edit-pass_page">
            <form className="pass-edit-user" onSubmit={handleSubmit(popUpConfirm)}>
                <div className="box-controller current-pass">
                    <Controller
                        name="currentPassword"
                        control={control}
                        defaultValue={''}
                        render={({ field: { value, onChange } }) => {
                            return (
                                <InputForm
                                    type="password"
                                    placeholder="Senha atual"
                                    label="Senha atual "
                                    name="currentPassword"
                                    value={value}
                                    onChange={onChange}
                                />
                            )
                        }}
                    />
                    <ErrorForm error={errors.currentPassword?.message} />
                </div>

                <div className="box-controller">
                    <Controller
                        name="newPassword"
                        control={control}
                        defaultValue={''}
                        render={({ field: { value, onChange } }) => {
                            return (
                                <InputForm
                                    type="password"
                                    placeholder="Nova senha"
                                    label="Nova senha "
                                    name="newPassword"
                                    value={value}
                                    onChange={onChange}
                                />
                            )
                        }}
                    />
                    <ErrorForm error={errors.newPassword?.message} />
                </div>

                <div className="box-controller">
                    <Controller
                        name="newPasswordConf"
                        control={control}
                        defaultValue={''}
                        render={({ field: { value, onChange } }) => {
                            return (
                                <InputForm
                                    type="password"
                                    placeholder="Confirmação de senha"
                                    label="Confirmação de senha  "
                                    name="newPasswordConf"
                                    value={value}
                                    onChange={onChange}
                                />
                            )
                        }}
                    />
                    <ErrorForm error={errors.newPasswordConf?.message} />
                </div>
                <div className="box-buttons">
                    <Button placeholder="Cancelar" type="button" onClick={() => navigate(-1)} />
                    <Button placeholder="Salvar Alterações" type="submit" />
                </div>
            </form>
            {isLoading ? (
                <div className="loader-page">
                    <SpinnerLoader />
                </div>
            ) : (
                <></>
            )}
        </div>
    )
}
